import { z } from 'zod';
export const OrganizationBadgeSchema = z.object({
    id: z.number().optional(),
    image: z.string().optional(),
    content: z.string().optional()
});
//# sourceMappingURL=organizationBadgeSchema.js.map